export default {
  'see-more': 'Lire la suite',
  'see-less': 'Lire moins',
};
